// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--36KWw";
export var layoutCream = "Layout-module--layout--cream--29Bwe";
export var layout__btpattern = "Layout-module--layout__btpattern--3Mdi_";
export var layout__btarc = "Layout-module--layout__btarc--21bl_";
export var layout__content = "Layout-module--layout__content--1wIi9";
export var layout__header = "Layout-module--layout__header--tKyCA";
export var layout__logo = "Layout-module--layout__logo--4OKvk";
export var fadeOutAnimation = "Layout-module--fadeOutAnimation--1774U";
export var fadeInAnimation = "Layout-module--fadeInAnimation--2ssG6";